import { render, staticRenderFns } from "./AxionInputEmailSearchSelect.vue?vue&type=template&id=8c71933c&scoped=true&"
import script from "./AxionInputEmailSearchSelect.vue?vue&type=script&lang=ts&"
export * from "./AxionInputEmailSearchSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AxionInputEmailSearchSelect.vue?vue&type=style&index=0&id=8c71933c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.10.1_babel-core@7.0.0-bridge.0_cache-loader@4.1.0_css-loader@3.6.0_react-dom@18_vyrjir3tafa6d7xmeapelwsujq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71933c",
  null
  
)

export default component.exports